import { LinearGradient } from "expo-linear-gradient";
import React, { useEffect, useState } from 'react';
import { Image, Text, TouchableOpacity, View } from 'react-native';
import { Checkbox } from 'react-native-paper';

import HeaderDefault from '../../components/HeaderDefault';

import styles from "./styles";
import { FormattedMessage } from "react-intl";

const BuyToken = ({ navigation, route }) => {
    const [checked, setChecked] = useState(false);
    const [qtd, setQtd] = useState();
    const [token, setToken] = useState({
        actives: [{
            active: true,
            amount_token: 0,
            blockchain_id: "",
            category: 0,
            client_id: 0,
            created_at: "",
            deadline_token: "",
            description: "",
            file_id: 0,
            final_letra: 0,
            final_linha: 0,
            id: 0,
            mime_type: "",
            min_value_token: 0.00,
            name: "",
            name_token: "",
            path: "",
            single_value: 0,
            size: 0,
            total_lote: 0,
            total_value_token: 0.00,
            type_value: "",
            updated_at: ""
        }],
        "files_actives": [],
        "tokens": [],
    });
    const [valueCoin, setValueCoin] = useState(0);

    useEffect(() => {
        setToken(route.params.token);
        setQtd(JSON.stringify(route.params.qtd));
        //console.log(route.params.token)
    }, []);

    return (
        <>
            
            <HeaderDefault title={<FormattedMessage id="buytoken.headerConfirmarCompra"/>} />
            <View style={styles.content}>
                <View style={styles.token_header_container}>
                    <Image source={{ uri: token.actives !== undefined ? `https://filesgpx.s3.us-east-2.amazonaws.com/${token.actives[0].path}` : '' }} style={styles.token_header_image} />
                    <Text style={styles.token_header_title}>{token.actives[0].name_token ? token.actives[0].name_token : "GPX"}</Text>
                </View>
                <View style={styles.contentAmount}>
                    <Text style={styles.titlePage}>  <FormattedMessage id="buytoken.quantidade"/></Text>
                    <Text style={styles.textInputAmount}>{qtd}</Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.descriptionPrice}>
                        <FormattedMessage id="buytoken.ultimoPreco" /></Text>
                    <Text style={styles.price}>
                    <FormattedMessage id="buytoken.000.000Gpx" />
                        </Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.descriptionPrice}>
                    <FormattedMessage id="buytoken.precoVenda" />
                    </Text>
                    <Text style={styles.price}>{token ? token.single_value : "000.000,00"}  
                    <FormattedMessage id="buytoken.gpx" />
                    </Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.descriptionPrice}>
                    <FormattedMessage id="buytoken.precoMercado" />
                    </Text>
                    <Text style={styles.price}>
                        <FormattedMessage id="buytoken.000.000Gpx" />
                        </Text>
                </View>
            </View>

            <View style={styles.contentCheckbox}>
                <Checkbox
                    status={checked ? 'checked' : 'indeterminate'}
                    onPress={() => {
                        setChecked(!checked);

                    }}
                />
                <Text>
                <FormattedMessage id="buytoken.comprarPrecoMercado" />
                    </Text>
            </View>

            <View style={styles.contentBtn}>
                <TouchableOpacity onPress={() => navigation.navigate('ConfirmPassword', { qtd: qtd, valueCoin: valueCoin, market: checked, purchase: true })}>
                    <LinearGradient
                        start={{ x: -1, y: 0 }}
                        end={{ x: 1, y: 0 }}
                        colors={["#196059", "#196059"]}
                        style={styles.btn}
                    >
                        <Text style={styles.textBtn}> 
                        <FormattedMessage id="buytoken.continuarMaiuscula" />
                        </Text>
                    </LinearGradient>
                </TouchableOpacity>
            </View>
        </>
    );
}

export default BuyToken;